module.exports = __webpack_public_path__ + "static/img/h_2_38.cad233e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h_2_38.png
// module id = DAZn
// module chunks = 0